<div class="row" style="margin-top: 20px; margin-right: 0; flex-direction: column;">
  <div class="col-3"></div>
  <div class="col-3">
    <mat-card>
      <mat-card-header>
        <mat-card-title>
          Ihre Daten - Kundenkennung: <strong>{{user?.username}}</strong>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content fxLayoutAlign="center" *ngIf="loading">
        <mat-spinner diameter="30"></mat-spinner>
      </mat-card-content>
      <mat-card-content fxLayout="wrap row" *ngIf="!loading">
        <div fxFlex="35">
          <mat-form-field style="width: 100%">
            <mat-label>Vorname</mat-label>
            <input matInput [(ngModel)]="user.vorname" maxlength="20">
          </mat-form-field>
        </div>
        <div fxFlex="35" style="margin-left: 20px;">
          <mat-form-field style="width: 100%;">
            <mat-label>Nachname</mat-label>
            <input matInput [(ngModel)]="user.nachname" maxlength="20">
          </mat-form-field>
        </div>
      </mat-card-content>
      <mat-card-footer *ngIf="!loading">
        <button mat-raised-button color="primary" style="width: 100%" [disabled]="savingUser" (click)="saveUser()">
          Speichern
        </button>
      </mat-card-footer>
    </mat-card>
  </div>
  <div class="col-3" *ngIf="user.role != 'ROLE_APOTHEKE'">
    <mat-card>
      <mat-card-header>
        <mat-card-title>
          Passwort ändern
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field>
          <mat-label>
            Aktuelles Passwort
          </mat-label>
          <input matInput [(ngModel)]="pwData.currentPassword" required type="password">
        </mat-form-field>
        <mat-form-field style="margin-left: 10px;">
          <mat-label>
            Neues Passwort
          </mat-label>
          <input matInput [(ngModel)]="pwData.newPassword" required type="password">
        </mat-form-field>
        <mat-form-field style="margin-left: 10px; width: 200px;">
          <mat-label>
            Neues Passwort wiederholen
          </mat-label>
          <input matInput [(ngModel)]="pwData.newPasswordRepeat" required type="password">
        </mat-form-field>
      </mat-card-content>
      <mat-card-footer>
        <button mat-raised-button style="width: 100%;" color="primary" (click)="savePassword()" [disabled]="savingPassword">
          Speichern
        </button>
      </mat-card-footer>
    </mat-card>
  </div>
  <div class="col-3" *ngIf="user.role == 'ROLE_APOTHEKE'">
    <mat-card>
      <mat-card-header>
        <mat-card-title>
          Bestell-E-Mail ändern
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field style="width: 100%;">
          <mat-label>
            Bestell-E-Mail
          </mat-label>
          <input matInput [(ngModel)]="orderEmail" required type="email">
        </mat-form-field>
      </mat-card-content>
      <mat-card-footer>
        <button mat-raised-button style="width: 100%;" color="primary" (click)="saveOrderEmail()" [disabled]="savingOrderEmail">
          Speichern
        </button>
      </mat-card-footer>
    </mat-card>
  </div>
  <div class="col-3" *ngIf="user.role == 'ROLE_APOTHEKE'">
    <mat-card>
      <mat-card-header>
        <mat-card-title>
          BGA ändern
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field style="width: 100%;">
          <mat-label>
            BGA
          </mat-label>
          <input matInput [(ngModel)]="bga" required type="number">
        </mat-form-field>
      </mat-card-content>
      <mat-card-footer>
        <button mat-raised-button style="width: 100%;" color="primary" (click)="saveBga()" [disabled]="savingBga">
          Speichern
        </button>
      </mat-card-footer>
    </mat-card>
  </div>
</div>

<div class="row mt-5" style="margin-right: 0; flex-direction: column;" *ngIf="user && user.role == 'ROLE_APOTHEKE'">
  <div class="col-3"></div>
  <div class="col-2">
    <a href="assets/anleitung_bestellung.pdf" style="cursor: pointer; text-decoration: none;" target="__blank" download>
      <mat-card>
        <mat-card-content>
          <h3>So funktioniert's...</h3>
        </mat-card-content>
      </mat-card>
    </a>
  </div>
</div>

<div style="position: absolute; bottom: 10px; right: 10px; margin-right: 0;" *ngIf="user && user.role == 'ROLE_APOTHEKE'">
  <a href="https://digibest.eu/wp-content/uploads/dsg-impressum-digibest-eu-171220-151823.pdf" target="__blank">Impressum</a> &nbsp;
  <a href="https://digibest.eu/wp-content/uploads/dsg-dse-digibest-eu-161220-161959.pdf" target="__blank">Datenschutz</a>
</div>

